import React, { Fragment, useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import "react-toastify/dist/ReactToastify.css";
import DataTableExtensions from "react-data-table-component-extensions";
import { useSelector } from "react-redux";
import { toastDelPermission } from "../../utils/toastPermission";
import { useHistory } from "react-router-dom";
const ListDatatable = ({
  id,
  myData,
  myClass,
  multiSelectOption,
  pagination,
  setActiveId,
  setOpen,
}) => {
  const result = useSelector((state) => state.admin);
  const { loginAdmin } = result || {};
  const { role } = loginAdmin || [];
  const [data, setData] = useState();
  const history = useHistory();

  useEffect(() => {
    setData(myData);
  }, [myData]);
  let delRole = role?.some((r) =>
    ["suUsers", "superAdmin", "delCategory"].includes(r),
  );
  let editRole = role?.some((r) =>
    ["suUsers", "superAdmin", "writeCategory"].includes(r),
  );

  const columnDefs = [
    {
      name: "Flag",
      cell: (row) => (
        <FlagImage code={row.restrictedCountry?.code?.toLowerCase()} />
      ),
    },

    {
      name: "Country Name",
      selector: (row) => row.restrictedCountry?.name,
      sortable: true,
    },

    {
      name: "Restricted States",
      cell: (row) => {
        if (row.blockWholeCountry) {
          return (
            <span style={{ color: "red", fontWeight: 600 }}>
              Whole Country Blocked
            </span>
          );
        }

        if (
          Array.isArray(row.restrictedState) &&
          row.restrictedState.length > 0
        ) {
          return (
            <div className="text-left">
              {row.restrictedState.map((state, index) => (
                <div key={index} style={{ fontSize: 13 }}>
                  • {state}
                </div>
              ))}
            </div>
          );
        }

        return <span>-</span>;
      },
    },

    {
      name: "Status",
      selector: (row) => (row.isEnabled ? "Active" : "Inactive"),
      sortable: true,
    },

    {
      name: "Remove",
      cell: (row) => (
        <ActionButton
          row={row}
          handleDelete={handleDelete}
          delRole={delRole}
          handleEdit={handleEdit}
        />
      ),
    },
  ];

  useEffect(() => {
    const check = delRole || editRole;
    if (!check) {
      columnDefs.pop();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [columnDefs]);

  const handleDelete = (id) => {
    setActiveId(id);
    setOpen(true);
  };

  const handleEdit = (id) => {
    setActiveId(id);
    history.push(`/add-country?id=${id}`);
  };

  return (
    <div>
      <Fragment>
        <DataTableExtensions
          columns={columnDefs}
          data={data}
          print={false}
          export={false}>
          <DataTable
            data={data}
            columns={columnDefs}
            className={myClass}
            pagination
            striped={true}
            center={true}
          />
        </DataTableExtensions>
      </Fragment>
    </div>
  );
};

const ActionButton = ({ row, handleDelete, delRole, handleEdit }) => {
  return (
    <div className="action-btn">
      {delRole && (
        <span>
          <i
            onClick={() =>
              delRole ? handleDelete(row._id) : toastDelPermission("category")
            }
            className="fa fa-trash"
            disabled="disabled"
            style={{
              width: 35,
              fontSize: 20,
              padding: 11,
              color: "#e4566e",
            }}></i>
        </span>
      )}

      <span>
        <i
          onClick={() => handleEdit(row._id)}
          className="fa fa-pencil"
          disabled
          style={{
            width: 35,
            fontSize: 20,
            padding: 11,
            color: "rgb(40, 167, 69)",
          }}></i>
      </span>
    </div>
  );
};

const FlagImage = ({ code }) => {
  return (
    <div className="flag-image">
      <img
        src={`https://flagcdn.com/${code}.svg`}
        alt="logo"
        className="rounded-0"
      />
    </div>
  );
};

export default ListDatatable;
